module.exports = __webpack_public_path__ + "files/2f07a6a2d396ef553bb4189700cec10d.png";